import React from "react";
import "./Navbar.css";
import { Link } from "react-router-dom";

function Navbar() {
    const scrollToSection = (id) => {
        const section = document.getElementById(id);
        if (section) {
            section.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <nav className="navbar navbar-expand-lg bg-white border-bottom">
            <div className="container">
                <Link to="/" className="navbar-brand logo d-flex align-items-center">
                    <i className="fas fa-shield-alt"></i>
                    <span>Berimbolo Security</span>
                </Link>
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarNav"
                    aria-controls="navbarNav"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div
                    style={{ backgroundColor: "#ffffff", width: "100%" }}
                    className="collapse navbar-collapse"
                    id="navbarNav"
                >
                    <div className="navbar-nav nav-links ms-auto" >
                        <li className="nav-item">
                            <button
                                className="nav-link"
                                onClick={() => scrollToSection("home-section")}
                            >
                                Home
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className="nav-link"
                                onClick={() => scrollToSection("services-section")}
                            >
                                Services
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className="nav-link"
                                onClick={() => scrollToSection("products-section")}
                            >
                                Products
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className="nav-link"
                                onClick={() => scrollToSection("testimonials-section")}
                            >
                                Testimonials
                            </button>
                        </li>
                        <li className="nav-item">
                            <button
                                className="nav-link"
                                onClick={() => scrollToSection("contactus-section")}
                            >
                                Contact
                            </button>
                        </li>
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default Navbar;
